import { ApiError, AppThunk } from "../misc"
import { TrainingVideoType } from "../reducers/trainingVideos";

export enum TRAINING_VIDEOS_ACTIONS {
  FETCH_TRAINING_VIDEOS_START = "FETCH_TRAINING_VIDEOS_START",
  FETCH_TRAINING_VIDEOS_SUCCESS = "FETCH_TRAINING_VIDEOS_SUCCESS",
  FETCH_TRAINING_VIDEOS_ERROR = "FETCH_TRAINING_VIDEOS_ERROR",
}

export type TRAINING_VIDEOS_ACTION_TYPES = FetchTrainingVideosAction

export type FetchTrainingVideosAction = {
  type: TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_START | TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_SUCCESS | TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_ERROR,
  payload: {
    items: TrainingVideoType[],
  },
  error?: ApiError
}

export const doGetTrainingVideos = (): AppThunk => async (dispatch, getState, api) => {
  dispatch({type: TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_START});
  try {
    let data = await api.fetchTrainingVideos();

    const vimeoRe = /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:[a-z]*\/)*([0-9]{6,11})[?]?.*/

    let trainingVideos: TrainingVideoType[] = data.training_videos?.reduce((acc: TrainingVideoType[], item) => {
      const urlMatches = item["field-video"]["field-media-oembed-video"].match(vimeoRe);
      let vimeoId: number;

      if (urlMatches) {
        vimeoId = parseInt(urlMatches[1]);
        acc.push({
          id: item.id,
          title: item.title,
          vimeoId: vimeoId,
        });
      }

      return acc;
    }, []);

    return dispatch({
      type: TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_SUCCESS,
      payload: {
        items: trainingVideos,
      }
    } as FetchTrainingVideosAction);

  } catch (error) {
    let message = "An unknown error has occured"

    dispatch({
      type: TRAINING_VIDEOS_ACTIONS.FETCH_TRAINING_VIDEOS_ERROR,
      error: {
        userMessage: message
      }
    });
  }
}